import { createSlice } from "@reduxjs/toolkit";
import { ITourInitialState } from "@/types/tour.types";
import {
  getAllHotelIncremental,
  getAllMenuSectors,
  getAllRoomTypes,
  getAllSectorBySectorType,
  getAllSectorIncremental,
  getAllTours,
  getAllToursWithSectors,
  getTourDetails,
} from "@/services/tour.services";

const initialState: ITourInitialState = {
  loading: false,
  menuLoading: false,
  formLoading: false,
  error: "",
  SectorList: [],
  HotelList: [],
  ActiveSectorList: [],
  MenuDomesticSectorList: [],
  MenuInternationalSectorList: [],
  TourList: [],
  TourDetails: {},
  RoomTypeList: [],
  TourListData: { TourList: [] },
  FilterTourDetails: {
    RegionID: "",
    TravelType: "",
    IsHimalayanTreks: "",
    SectorID: "",
    Rate: [],
    NoOfDays: [],
    SpecialityType: "",
    OrderBy: "ORDER BY RATE ASC",
    CityName: "",
    SectorName: "",
    SectorURL: "",
    SpecialityURL: "",
    CityURL: "",
    TourType: [],
    PageIndex: 1,
    PageSize: 100,
  },
};

const tourSlice = createSlice({
  name: "tour",
  initialState,
  reducers: {
    setFilterTourDetails: (state, action) => {
      state.FilterTourDetails = action.payload;
    },
    clearFilterTourDetails: (state) => {
      state.FilterTourDetails = initialState.FilterTourDetails;
    },
    clearTourDetails: (state) => {
      state.TourDetails = initialState.TourDetails;
    },
    clearTourList: (state) => {
      state.TourList = initialState.TourList;
    },
    clearActiveSectorList: (state) => {
      state.ActiveSectorList = initialState.ActiveSectorList;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllMenuSectors.pending, (state) => {
      state.menuLoading = true;
    });
    builder.addCase(getAllMenuSectors.fulfilled, (state, action) => {
      state.menuLoading = false;
      state.MenuDomesticSectorList =
        (action.payload &&
          action.payload?.length > 0 &&
          action.payload?.filter(
            (sector: any) => sector?.SectorType === "DOMESTIC",
          )) ||
        [];
      state.MenuInternationalSectorList =
        (action.payload &&
          action.payload?.length > 0 &&
          action.payload?.filter(
            (sector: any) => sector?.SectorType === "INTERNATIONAL",
          )) ||
        [];
      state.error = "";
    });
    builder.addCase(getAllMenuSectors.rejected, (state, action) => {
      state.menuLoading = false;
      state.MenuDomesticSectorList = [];
      state.MenuInternationalSectorList = [];
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(getAllTours.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getAllTours.fulfilled, (state, action) => {
      state.loading = false;
      state.TourList = action.payload || [];
      state.error = "";
    });
    builder.addCase(getAllTours.rejected, (state, action) => {
      state.loading = false;
      state.TourList = [];
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(getAllRoomTypes.pending, (state) => {
      state.formLoading = true;
    });
    builder.addCase(getAllRoomTypes.fulfilled, (state, action) => {
      state.formLoading = false;
      state.RoomTypeList = action.payload || [];
      state.error = "";
    });
    builder.addCase(getAllRoomTypes.rejected, (state, action) => {
      state.formLoading = false;
      state.RoomTypeList = [];
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(getTourDetails.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getTourDetails.fulfilled, (state, action) => {
      state.loading = false;
      state.TourDetails = action.payload;
      state.error = "";
    });
    builder.addCase(getTourDetails.rejected, (state, action) => {
      state.loading = false;
      state.TourDetails = initialState.TourDetails;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(getAllSectorIncremental.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getAllSectorIncremental.fulfilled, (state, action) => {
      state.loading = false;
      state.SectorList = action.payload || [];
      state.error = "";
    });
    builder.addCase(getAllSectorIncremental.rejected, (state, action) => {
      state.loading = false;
      state.SectorList = [];
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(getAllHotelIncremental.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getAllHotelIncremental.fulfilled, (state, action) => {
      state.loading = false;
      state.HotelList = action.payload || [];
      state.error = "";
    });
    builder.addCase(getAllHotelIncremental.rejected, (state, action) => {
      state.loading = false;
      state.HotelList = [];
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(getAllToursWithSectors.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getAllToursWithSectors.fulfilled, (state, action) => {
      state.loading = false;
      state.TourListData = action.payload;
      state.error = "";
    });
    builder.addCase(getAllToursWithSectors.rejected, (state, action) => {
      state.loading = false;
      state.TourListData = initialState.TourListData;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(getAllSectorBySectorType.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getAllSectorBySectorType.fulfilled, (state, action) => {
      state.loading = false;
      state.ActiveSectorList = action.payload || [];
      state.error = "";
    });
    builder.addCase(getAllSectorBySectorType.rejected, (state, action) => {
      state.loading = false;
      state.ActiveSectorList = [];
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export default tourSlice.reducer;
export const {
  setFilterTourDetails,
  clearFilterTourDetails,
  clearTourList,
  clearTourDetails,
  clearActiveSectorList,
} = tourSlice.actions;
